import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

/// This is a container for making an item interactive to navigate to a different url
class LinkButtonA extends React.PureComponent {
    render() {
        const {
            children, href, isdisabled, buttonclass, clickHandler, className, target,
        } = this.props;

        // isdisabled is returning an empty string - it really should be a boolean....
        // if(isdisabled)
        if (isdisabled === '') {
            // https://stackoverflow.com/questions/4855168/what-is-href-and-why-is-it-used/21397285#21397285

            return (
                <a
                    className={`${styles.linkbuttona} ${className} button ${buttonclass} ${styles['is-inactive']}`}
                    href="#!"
                >
                    {children}
                </a>
            );
        }
        return (
            <a
                className={`${styles.linkbuttona} ${className} button ${buttonclass}`}
                href={href}
                onClick={clickHandler}
                target={target}
            >
                {children}
            </a>
        );
    }
}

LinkButtonA.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
    target: PropTypes.string,
    isdisabled: PropTypes.bool,
    buttonclass: PropTypes.string,
    clickHandler: PropTypes.func,
    className: PropTypes.string,
};

LinkButtonA.defaultProps = {
    href: '#!',
    target: '_self',
    isdisabled: false,
    buttonclass: 'is-outlined',
    clickHandler: () => { },
    className: '',
};

export default LinkButtonA;
